import { render, staticRenderFns } from "./ModalCurrency.vue?vue&type=template&id=39a46120&scoped=true&"
import script from "./ModalCurrency.vue?vue&type=script&lang=js&"
export * from "./ModalCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a46120",
  null
  
)

export default component.exports